(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.webtech = {
    attach: function (context) {

      $(".webtech__export__html").unbind().click(function (e) {
        e.preventDefault();
        Drupal.behaviors.webtech.copyHTML("webtech__content_table");
        $(".webtech__export__html").text("HTML Copied!");
        setTimeout(function() {
          $(".webtech__export__html").text("Export as HTML");
        }, 2000);
      });

      $(".webtech__export__csv").unbind().click(function(e) {
        e.preventDefault();
        $(".webtech__content_table").tableToCSV({timestamp: false});
      });

      $(".webtech__export__overview__csv").unbind().click(function(e) {
        e.preventDefault();
        $(".webtech-notes-overview-table").tableToCSV({trSelector: ".csv-export", tdExclude: ".webform-checkbox"});
      });

      $(".webform-checkbox-row input[type='checkbox']").unbind().change(function(e){
        var tr = $(this).closest("tr");
        if($(this).is(":checked")) {
          $(tr).addClass("csv-export");
        } else {
          $(tr).removeClass("csv-export");
        }
      });

      $(".webform-checkbox-header input[type='checkbox']").unbind().change(function(e){
        if($(this).is(":checked")) {
          $(".webform-checkbox-row input[type='checkbox']").prop( "checked", true ).change();
        } else {
          $(".webform-checkbox-row input[type='checkbox']").prop( "checked", false ).change();
        }
      });


    },

    copyHTML(elementId) {
      var aux = document.createElement("input");
      aux.setAttribute("value", document.getElementById(elementId).outerHTML);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
    }


  };

})(jQuery, Drupal);
